import { Sparkles, MessageSquare, FileText, Wand2, Bot, Mic, FileDown } from "lucide-react";

// Frontend mirror of the user-facing items in apps/wallet/feature_costs.py.
// Source of truth lives in the backend dict; this list is for display only,
// so prices showing here may briefly diverge if the backend dict changes
// before the SPA redeploys. That's acceptable — actual debit happens in
// CreditGatedMixin against the live FEATURE_COSTS.
const FEATURES = [
  {
    key: "ai_tagging",
    icon: Sparkles,
    label: "AI Tag a match",
    cost: 15,
    desc: "Auto-fill missing stroke / connection / outcome on every ball.",
  },
  {
    key: "ai_suggest_ball",
    icon: Wand2,
    label: "AI Suggest a ball",
    cost: 7,
    desc: "Per-ball AI fill from the video frames around the delivery.",
    badge: "closed beta",
  },
  {
    key: "match_summary_report",
    icon: FileText,
    label: "AI match report",
    cost: 30,
    desc: "Narrative summary of the whole match — runs, turning points, MOM.",
  },
  {
    key: "match_report_pdf",
    icon: FileDown,
    label: "Printable PDF report",
    cost: 20,
    desc: "Download the full scorecard + analytics as a polished PDF.",
  },
  {
    key: "commentary_regenerate_ball",
    icon: MessageSquare,
    label: "Regenerate ball commentary",
    cost: 3,
    desc: "Refresh the auto-commentary for one delivery.",
  },
  {
    key: "chat_haiku_msg",
    icon: Bot,
    label: "Scorer chat — Haiku (per message)",
    cost: 2,
    desc: "Ask the assistant to undo, edit, or look up rules. Fast & cheap.",
  },
  {
    key: "chat_sonnet_msg",
    icon: Bot,
    label: "Scorer chat — Sonnet (per message)",
    cost: 5,
    desc: "Deeper reasoning for rule interpretation or complex edits.",
  },
  {
    key: "voice_ball_charge",
    icon: Mic,
    label: "Voice scoring (per ball)",
    cost: 2,
    desc: "Hands-free ball scoring — only debits balls saved with voice on.",
  },
];

export default function WhatYouCanDo() {
  return (
    <div className="bg-bg-primary border border-border-default rounded-xl p-5">
      <h3 className="text-sm font-semibold text-text-primary mb-1">
        What you can do with Zencredits
      </h3>
      <p className="text-xs text-text-secondary mb-4">
        Each AI feature debits Zencredits the moment it's used. Most matches
        cost under ₹50 in AI usage if you only run AI Tag once.
      </p>
      <ul className="grid gap-2 sm:grid-cols-2">
        {FEATURES.map((f) => {
          const Icon = f.icon;
          return (
            <li
              key={f.key}
              className="flex items-start gap-3 bg-bg-secondary/40 rounded-lg p-3 border border-bg-secondary"
            >
              <div className="w-8 h-8 rounded-md bg-button-primary/15 flex items-center justify-center shrink-0">
                <Icon className="w-4 h-4 text-button-primary" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm font-semibold text-text-primary">
                    {f.label}
                  </span>
                  <span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-emerald-500/15 text-emerald-300 border border-emerald-500/30 font-mono">
                    {f.cost} ZC
                  </span>
                  {f.badge && (
                    <span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-violet-500/15 text-violet-300 border border-violet-500/30">
                      {f.badge}
                    </span>
                  )}
                </div>
                <p className="text-xs text-text-secondary mt-0.5">{f.desc}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
